import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TEXT = {
  es: {
    sent: 'Invitaci\u00f3n enviada por correo. Si no le llega en unos minutos, copia el enlace y env\u00edaselo por WhatsApp.',
    cancelInvite: 'Cancelar invitaci\u00f3n',
    confirmCancel: '\u00bfCancelar la invitaci\u00f3n a {{email}}? El enlace dejar\u00e1 de funcionar.',
    cancelError: 'No se pudo cancelar la invitaci\u00f3n.',
    expired: 'Caducada: vuelve a invitar a esta persona para generar un enlace nuevo.',
    copy: 'Copiar enlace',
    copied: '\u00a1Copiado!',
    copyError: 'No se pudo copiar',
    whatsapp: 'Enviar por WhatsApp',
    created: 'Invitaci\u00f3n creada. Si el correo no llega, copia el enlace de la invitaci\u00f3n y env\u00edaselo por WhatsApp.',
    hint: 'Si el correo no llega, copia el enlace y env\u00edaselo solo a la persona invitada.',
    message: 'Te invito a unirte a mi equipo en Flash Multiservice. Crea tu cuenta aqu\u00ed:',
  },
  en: {
    sent: 'Invitation sent by email. If it does not arrive within a few minutes, copy the link and send it via WhatsApp.',
    cancelInvite: 'Cancel invitation',
    confirmCancel: 'Cancel the invitation to {{email}}? The link will stop working.',
    cancelError: 'The invitation could not be cancelled.',
    expired: 'Expired: invite this person again to generate a new link.',
    copy: 'Copy link',
    copied: 'Copied!',
    copyError: 'Could not copy',
    whatsapp: 'Send via WhatsApp',
    created: 'Invitation created. If the email does not arrive, copy the invitation link and send it via WhatsApp.',
    hint: 'If the email does not arrive, copy the link and send it only to the invited person.',
    message: 'I am inviting you to join my team on Flash Multiservice. Create your account here:',
  },
  fr: {
    sent: 'Invitation envoy\u00e9e par e-mail. Si elle n\u2019arrive pas d\u2019ici quelques minutes, copiez le lien et envoyez-le par WhatsApp.',
    cancelInvite: 'Annuler l\u2019invitation',
    confirmCancel: 'Annuler l\u2019invitation de {{email}} ? Le lien ne fonctionnera plus.',
    cancelError: 'Impossible d\u2019annuler l\u2019invitation.',
    expired: 'Expir\u00e9e : invitez \u00e0 nouveau cette personne pour g\u00e9n\u00e9rer un nouveau lien.',
    copy: 'Copier le lien',
    copied: 'Copi\u00e9 !',
    copyError: 'Impossible de copier',
    whatsapp: 'Envoyer par WhatsApp',
    created: 'Invitation cr\u00e9\u00e9e. Si l\u2019e-mail n\u2019arrive pas, copiez le lien de l\u2019invitation et envoyez-le par WhatsApp.',
    hint: 'Si l\u2019e-mail n\u2019arrive pas, copiez le lien et envoyez-le uniquement \u00e0 la personne invit\u00e9e.',
    message: 'Je t\u2019invite \u00e0 rejoindre mon \u00e9quipe sur Flash Multiservice. Cr\u00e9e ton compte ici :',
  },
};

export const getInviteText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;

export function useInviteText() {
  const { i18n } = useTranslation();
  return getInviteText(i18n.language);
}

async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const area = document.createElement('textarea');
  area.value = text;
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(area);
  if (!ok) throw new Error('copy failed');
}

function InviteLinkButton({ url }) {
  const tx = useInviteText();
  const [state, setState] = useState('');
  if (!url) return null;

  const handleCopy = async () => {
    try {
      await copyText(url);
      setState('copied');
    } catch (err) {
      setState('error');
    }
    setTimeout(() => setState(''), 2500);
  };

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${tx.message} ${url}`)}`;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      <button
        type="button"
        onClick={handleCopy}
        className="bg-transparent border border-edge text-white text-xs px-3 py-1.5 rounded cursor-pointer"
      >
        {state === 'copied' ? tx.copied : state === 'error' ? tx.copyError : tx.copy}
      </button>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-transparent border border-[#166534] text-[#4ade80] text-xs px-3 py-1.5 rounded cursor-pointer no-underline"
      >
        {tx.whatsapp}
      </a>
    </div>
  );
}

export default InviteLinkButton;